import { configureStore } from '@reduxjs/toolkit'
import {menuToggles, menuActive, clientLogoReducer, siteClientLogoReducer, userProfileReducer, notificationReducer} from "./reducer"

export default configureStore({
    reducer: {
        menuToggle : menuToggles,
        active : menuActive,
        clientLogo: clientLogoReducer,
        siteClientLogo: siteClientLogoReducer,
        userProfile: userProfileReducer,
        notification: notificationReducer,
    }
})